import { useEffect } from "react";

/**
 * Analytics loader for Meta Pixel and Google Tag (GA4).
 *
 * To activate, set the IDs in /app/frontend/.env:
 *   REACT_APP_META_PIXEL_ID=1234567890
 *   REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 *
 * Both are optional — only the ones with IDs will load.
 */
const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

const injectScript = (src) => {
  if (document.querySelector(`script[src="${src}"]`)) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

const Analytics = () => {
  useEffect(() => {
    // ---- Meta Pixel ----
    if (META_PIXEL_ID && !window.fbq) {
      /* eslint-disable */
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      /* eslint-enable */
      window.fbq("init", META_PIXEL_ID);
      window.fbq("track", "PageView");
    }

    // ---- Google Tag / GA4 ----
    if (GA_MEASUREMENT_ID) {
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: true });
    }
  }, []);

  return null;
};

export default Analytics;
